"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var ProgressBar = function ProgressBar(_ref) {
  var className = _ref.className,
    style = _ref.style,
    value = _ref.value;
  var backgroundColor = style.backgroundColor,
    color = style.color,
    height = style.height,
    width = style.width;
  var progress;
  if (value > 100) {
    progress = 100;
  } else if (value < 0) {
    progress = 0;
  } else {
    progress = value || 0;
  }
  return /*#__PURE__*/_react["default"].createElement(StyledProgressBarContainer, {
    className: className,
    style: {
      color: color
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledProgressWrapper, {
    style: {
      width: width,
      height: height,
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledProgressBar, {
    style: {
      width: "".concat(progress, "%")
    }
  })));
};
var StyledProgressBarContainer = _styledComponents["default"].div.withConfig({
  displayName: "ProgressBar__StyledProgressBarContainer",
  componentId: "sc-1grdcx8-0"
})(["display:flex;justify-content:center;align-items:center;color:#FD9D00;"]);
var StyledProgressWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ProgressBar__StyledProgressWrapper",
  componentId: "sc-1grdcx8-1"
})(["width:300px;height:2px;background-color:#EFEFEF;"]);
var StyledProgressBar = _styledComponents["default"].div.withConfig({
  displayName: "ProgressBar__StyledProgressBar",
  componentId: "sc-1grdcx8-2"
})(["width:0;height:100%;transition:width 100ms ease;background-color:currentColor;"]);
ProgressBar.defaultProps = {
  className: '',
  value: 0,
  style: {}
};
ProgressBar.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].number,
  style: _propTypes["default"].shape({
    width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    color: _propTypes["default"].string,
    backgroundColor: _propTypes["default"].string
  })
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(ProgressBar);